//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isUsingNewLayout } from '~/utils/isUsingNewLayout'
import layout from '~/mixins/layout'
import proseText from '~/mixins/proseText'

export default {
  mixins: [layout, proseText],
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: 'PageFaq',
    },
    imageSide: {
      type: Boolean,
      default: false,
    },
    image: {
      type: Object,
      default() {},
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    faqQuestionsAnswers: {
      type: Array,
      default: () => [],
    },
    isLandingpage: {
      type: Boolean,
      default: false,
    },
    anchorId: {
      type: Object,
      default: () => {},
    },
    pageId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      innerWidth: window.innerWidth,
      navScroll: {
        scroll: null,
        width: null,
        bounceWidth: 18,
      },
      illustrations: [
        {
          number: 1,
          src: require(`~/assets/img/element-connect-07.svg?data`),
          width: 143,
          height: 113,
          alt: '',
        },
      ],
    }
  },
  computed: {
    isUsingNewLayout() {
      return isUsingNewLayout(this.$i18n.locale)
    },
  },
  mounted() {},

  methods: {},
}
